import Route from '@ember/routing/route';
import type { ApplicationModel } from './application';

type RegisterUserData = {
  language: string;
  unit: string;
  languageCandidates: string[];
  unitCandidates: string[];
};

export type RegisterUserModel = RegisterUserData & ApplicationModel;

export default class RegisterUserRoute extends Route<RegisterUserModel> {
  override async model(): Promise<RegisterUserModel> {
    const response = await fetch(`registerWindowsUserInfo?_${Date.now()}`);
    const registerUserData = await (response.json() as Promise<RegisterUserData>);
    const applicationModel = this.modelFor('application') as ApplicationModel;
    return Object.assign({}, applicationModel, registerUserData);
  }
}
